import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.NEXTENGINE_SET_EC_GOODS_LIST]: (state, payload) => {
    state.ecGoodsList = payload.data.ecGoodsList

    const sortNumberList = payload.data.ecGoodsList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.maxSortNumber = Math.max(...sortNumberList)
    }
  },
  [mutationsTypes.NEXTENGINE_SET_EC_RECEIVEORDER_LIST]: (state, payload) => {
    state.ecReceiveOrderList = payload.data.ecReceiveOrderList

    const sortNumberList = payload.data.ecReceiveOrderList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.maxSortNumber = Math.max(...sortNumberList)
    }
  },
  [mutationsTypes.NEXTENGINE_SET_NEXTENGINE_COOPERATE_CONFIG_DATA]: (
    state,
    payload
  ) => {
    state.nextengineCooperateConfigData = payload.data
  },
  [mutationsTypes.LEDGER_SHEET_HEADER]: (state, response) => {
    state.ledgerSheetHeader = response.headers
    state.ledgerSheetData = response.data
  },
  [mutationsTypes.FILE_SET_UPLOAD_URL]: (state, payload) => {
    state.uploadUrl = payload.uploadUrl
  },
  [mutationsTypes.FILE_SET_CSV_UPLOAD_TOTAL]: (state, payload) => {
    state.csvUploadTotal = payload.total
  },
  [mutationsTypes.FILE_SET_CSV_UPLOAD_ERROR_LIST]: (state, payload) => {
    state.csvUploadErrorList = payload.errorList
  },
  [mutationsTypes.FILE_SET_CSV_UPLOAD_HISTORY_LIST]: (state, payload) => {
    state.csvUploadHistoryList = payload.data.exCsvFileList
  }
}

export default Mutations
